import * as _ from 'underscore';
import * as angular from 'angular';

class WizardAssignStep {
    pattern = '[A-Z]{1}\\d{12}$';
}

angular.module('naut').component('wizardAssignStep', {
    template: require('./wizard-assign-step.component.html'),
    controller: WizardAssignStep,
    controllerAs: 'ctrl',
    bindings: {
        assignType: '=',
        firstStickerNumber: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/wizard-assign-step/wizard-assign-step.component.ts